import { render } from "./ApplicationMark.vue?vue&type=template&id=2ea5da88"
const script = {}

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__